import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { individualpayments } from 'models/individualpayments'; // Importing individualpayments model

/**
 * PaymentHistoryView class extends JetView to create a payment history view.
 */
export default class PaymentHistoryView extends JetView {
    /**
     * Configures the view layout and properties.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const _ = this.app.getService('locale')._; // Localization service

        return {
            view: 'datatable', // Defines the view as a datatable
            select: true, // Enables row selection
            tooltip: true, // Enables tooltips for cells
            columns: [
                // Defines the columns of the datatable
                {
                    id: 'date', // Column ID
                    header: _('Fecha'), // Column header with localization
                    sort: 'date', // Sort type for the column
                    format: dateFormat, // Date format for display
                    width: 155, // Column width
                    tooltip: '', // Tooltip content
                },
                {
                    id: 'type', // Column ID
                    header: _('Tipo'), // Column header with localization
                    sort: 'string', // Sort type for the column
                    adjust: 'header', // Adjust column width to header
                    tooltip: (obj) => (obj.type ? 'Bought' : 'Sold'), // Tooltip based on type
                    template: (obj) => {
                        // Template for rendering the cell
                        let type = obj.type ? 'left bought' : 'right sold'; // Determine icon direction
                        return `<span class="webix_icon mdi mdi-arrow-${type}"></span>`; // Return icon HTML
                    },
                },
                {
                    id: 'item', // Column ID
                    header: _('Item'), // Column header with localization
                    sort: 'string', // Sort type for the column
                    fillspace: 8, // Fill space for responsive design
                    tooltip: '#item#', // Tooltip content
                },
                {
                    id: 'number', // Column ID
                    header: _('Quantity'), // Column header with localization
                    sort: 'int', // Sort type for the column
                    width: 67, // Column width
                    tooltip: '', // Tooltip content
                },
                {
                    id: 'sum', // Column ID
                    header: _('Cost'), // Column header with localization
                    sort: 'int', // Sort type for the column
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for the column
                    adjust: 'data', // Adjust column width to data
                    tooltip: '', // Tooltip content
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up data synchronization and event listeners.
     * @param {Object} view - The view instance.
     */
    init(view) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        view.sync(individualpayments, function () {
            // Synchronize view with individualpayments model
            if (cur_user) this.filter((obj) => obj.id % 6 === cur_user % 6); // Filter data based on user
        });
        this.on(this.app, 'person:select', (person) => {
            // Event listener for person selection
            individualpayments.waitData.then(() => {
                // Wait for data to be ready
                view.filter((obj) => {
                    // Filter data based on selected person
                    return obj.id % 6 === person.id % 6; // Filter condition
                });
            });
        });
    }
}

// FILE DOCUMENTED
